import { Card } from '@repo/ui/Card';
import { gql } from '@apollo/client';
import { useApolloClient } from '@apollo/client/react';
import { Button } from '@repo/ui/Button';
import { useZodForm } from '@repo/hooks/useZodForm';
import { useNavigate } from 'react-router';

import { Form } from '@repo/ui/Form';
import React from 'react';

export interface ActivateSubAccountProps {
  name: string;
  subAccountId: string;
  accountId: string | string[] | undefined;
}

const ActivateSubAccount = ({ subAccountId, accountId, name }: ActivateSubAccountProps) => {
  const navigate = useNavigate();
  const ACTIVATE_SUB_ACCOUNT = gql`
    mutation activateSubAccount($id: ID!) {
      activateAccount(id: $id) {
        account {
          id
        }
      }
    }
  `;

  const client = useApolloClient();
  const onSubmit = async () => {
    await client.mutate({
      mutation: ACTIVATE_SUB_ACCOUNT,
      variables: {
        id: subAccountId,
      },
    });
    setTimeout(() => {
      navigate(`/a/${accountId}/sub-accounts`);
    }, 2000);
  };

  const form = useZodForm({
    onSubmit,
  });

  return (
    <>
      <Card title="Activate sub account">
        <Form {...form}>
          <Form.Success>Sub account successfully activated.</Form.Success>
          <Form.Error>
            Unable to activate sub account. Please try again later or contact support if error
            persists.
          </Form.Error>

          <Button type="submit" disabled={false}>
            Activate Account
          </Button>
        </Form>
      </Card>
    </>
  );
};

export default ActivateSubAccount;
